module.exports = __webpack_public_path__ + "img/home-empresas-2.9fd8183.png";